import { ECampaign } from '@/context/borrower';
import { store } from '@/context/store';

import {
    CampaignVehicle,
    campaignVehicles,
    demoCampaignVehicles,
} from './campaignVehicles';
import { yamahaCampaignVehicles } from './yamahaCampaignVehicles';

export function getCampaignVehicles(): CampaignVehicle[] {
    const state = store.getState();
    const campaign = state.displayReducer.partner.campaign;
    const url = window.location.href;
    const isDemo = url.includes('demo');

    if (state.displayReducer.partner.vehicles) {
        const vehicles: CampaignVehicle[] = [];
        state.displayReducer.partner.vehicles.forEach((veh, i) => {
            vehicles.push({
                id: i,
                displayName: veh.name,
                nvic: veh.nvic,
            });
        });
        return vehicles;
    }

    if (campaign === ECampaign.YAMAHA) {
        return yamahaCampaignVehicles;
    } else if (campaign === ECampaign.DEMO || isDemo) {
        return demoCampaignVehicles;
    }

    return campaignVehicles;
}
